export default __webpack_public_path__ + "07b231a2f05538b3301ea4a8ba4be6d6.jpg";